import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getCollegeDetails } from "../../Services/HomeService";
import toast from "react-hot-toast";

import CollegeUniversityStep2 from "./Overview/CollegeUniversityStep2";
import CollegeUniversityStep3 from "./Overview/CollegeUniversityStep3";
import CollegeUniversityStep4 from "./Overview/CollegeUniversityStep4";
import CollegeUniversityStep5 from "./Overview/CollegeUniversityStep5";
import CollegeUniversityStep6 from "./Overview/CollegeUniversityStep6";
import CollegeUniversityStep7 from "./Overview/CollegeUniversityStep7";
import CollegeUniversityStep8 from "./Overview/CollegeUniversityStep8";
import CollegeUniversityStep9 from "./Overview/CollegeUniversityStep9";
import CollegeUniversityStep10 from "./Overview/CollegeUniversityStep10";
import CollegeUniversityStep11 from "./Overview/CollegeUniversityStep11";
import CollegeUniversityStep12 from "./Overview/CollegeUniversityStep12";
import CollegeUniversityStep13 from "./Overview/CollegeUniversityStep13";
import CollegeUniversityStep14 from "./Overview/CollegeUniversityStep14";
import CollegeUniversityStep15 from "./Overview/CollegeUniversityStep15";
import CollegeUniversityStep16 from "./Overview/CollegeUniversityStep16";
import CollegeUniversityStep17 from "./Overview/CollegeUniversityStep17";
import CollegeUniversityStep18 from "./Overview/CollegeUniversityStep18";
import FormStepProgress from "../../Component/FormStepProgress ";
import CollegeUniversityStep19 from "./Overview/CollegeUniversityStep19";

const headLineStyle = {
  textAlign: "center",
  fontSize: "30px",
  color: "rgb(131, 144, 155)",
  margin: "0px 0px 10px 0px",
  fontWeight: "bold",
};

const CollegeUniversityOverview = () => {
  const location = useLocation();
  const { college } = location.state || {};
  const [currentStep, setCurrentStep] = useState(1)
  const [data, setData] = useState(null)


  ////////////////////////////////////////////
  const transformData = (data) => {
    const transformObject = (obj) => {
      if (Array.isArray(obj)) {
        return obj.map(transformObject);
      } else if (obj && typeof obj === "object") {
        let newObj = { ...obj };

        // If course.category exists, create courseCategory as just the _id string
        if (newObj.course && newObj.course.category) {
          newObj.courseCategory = newObj.course.category._id;
          delete newObj.course.category;
        }

        // Recursively check other keys
        for (let key in newObj) {
          if (typeof newObj[key] === "object") {
            newObj[key] = transformObject(newObj[key]);
          }
        }
        return newObj;
      }
      return obj;
    };

    return transformObject(data);
  };

  ////////////////////////////////////////////

  const fetchCollegeDetails = async (id) => {
    try {
      const res = await getCollegeDetails(id);
      if (res?.status) {
        // setData(res?.data);
        const newData = transformData(res?.data);
        console.log("NDR74", newData);
        setData(newData);
      } else {
        // toast.error("Error while Fetching College Data");
      }
    } catch (error) {
      toast.error("failed to fetch College Data");
      console.error("Error fetching College:", error);
    }
  };



  const steps = {
    1: CollegeUniversityStep2,
    2: CollegeUniversityStep3,
    3: CollegeUniversityStep4,
    4: CollegeUniversityStep5,
    5: CollegeUniversityStep6,
    6: CollegeUniversityStep7,
    7: CollegeUniversityStep8,
    8: CollegeUniversityStep9,
    9: CollegeUniversityStep10,
    10: CollegeUniversityStep11,
    11: CollegeUniversityStep12,
    12: CollegeUniversityStep13,
    13: CollegeUniversityStep14,
    14: CollegeUniversityStep15,
    15: CollegeUniversityStep16,
    16: CollegeUniversityStep17,
    17: CollegeUniversityStep18,
    18: CollegeUniversityStep19
  };

  const StepComponent = steps[currentStep];
  const stepTab = [
    "Banner & About",
    "Eligibility",
    "Courses and Admissions",
    "Under fees table",
    "Counselling",
    "Application Process",
    "Placement",
    "Internship",
    "Recruiting",
    "Cut Off",
    "Ranking",
    "NIRF Ranking",
    "QS World Ranking",
    "QS World Ranking By Subject",
    "Facilities and Infrastructure",
    "Faculty",
    "Important Dates",
    "JEE Advance"
  ]

  useEffect(() => {
    console.log("KOI89",college);
    
    fetchCollegeDetails(college)
  }, [college])

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div style={headLineStyle} className="page-headline">
            College/University Overview Tab
          </div>
          <FormStepProgress totalStep={18} currentStep={currentStep} setCurrentStep={setCurrentStep} stepTab={stepTab} />
          {StepComponent && (
            <StepComponent
              data={data}
              setData={setData}
              setCurrentStep={setCurrentStep}
              currentStep={currentStep}
            />
          )}
        </div>
      </div >
    </>
  );
};

export default CollegeUniversityOverview;
